export const userApps = {
  'admin': ['上门回收', '便民驿站', '分拣中心'],
  'admin1': ['上门回收'],
  'admin2': [],
  'admin3': ['分拣中心']
}

export const appDetails = {
  '上门回收': {
    path: 'door-recycling',
    name: '上门回收',
    iconKey: 'shangmenhuihou'
  },
  '便民驿站': {
    path: 'service-station',
    name: '便民驿站',
    iconKey: 'bianminyizhan'
  },
  '分拣中心': {
    path: 'sorting-center',
    name: '分拣中心',
    iconKey: 'fenjianzhongxin'
  }
}